import React from "react";
import { Card} from "antd";

const NewsSort = () => {
  return (
    <Card style={{ borderRadius: 20, padding: 30 }}>
      <div style={{borderRadius: 20 }}>
        <div className="flex justify-around">
          <p>All Stories</p>
          <p>Soccer</p>
          <p>Basketball</p>
        </div>
        <div className="flex justify-around mt-10">
          <p>Tennis</p>
          <p>Cricket</p>
          <p>Hockey</p>
        </div>
        <div className="flex justify-around mt-10">
          <p>Handball</p>
          <p>Volleyball</p>
          <p>Baseball</p>
        </div>
      </div>
    </Card>
  );
};

export default NewsSort;
